var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Stepper from 'syf-component-library/ui/patterns/Stepper/Stepper';
import { TransactionStatus } from '../../../../const/transactionStatus';
import { cancelationPendingTranslationKey, disputeApprovedTranslationKey, disputeCompletedTranslationKey, disputeDeniedTranslationKey, disputeOpenedTranslationKey, disputeUnderReviewTranslationKey } from '../../../../helpers/getTranslationForTransactionStatus';
import { addDays, format, isAfter } from 'date-fns';
import useSelectedDispute from '../../../../hooks/useSelectedDispute';
import { t } from '../../../../strings/i18n/i18n';
import { StepDate, TrackerToolTip } from './subcomponents';
var disputeOpenedSteps = [
    {
        labelKey: disputeOpenedTranslationKey,
        status: 'active'
    },
    {
        labelKey: disputeUnderReviewTranslationKey,
        status: 'upcoming'
    },
    {
        labelKey: disputeCompletedTranslationKey,
        status: 'upcoming'
    }
];
var disputeUnderReviewSteps = [
    {
        labelKey: disputeOpenedTranslationKey,
        status: 'completed'
    },
    {
        labelKey: disputeUnderReviewTranslationKey,
        status: 'active'
    },
    {
        labelKey: disputeCompletedTranslationKey,
        status: 'upcoming'
    }
];
var disputeCompletedSteps = [
    {
        labelKey: disputeOpenedTranslationKey,
        status: 'completed'
    },
    {
        labelKey: disputeUnderReviewTranslationKey,
        status: 'completed'
    },
    {
        labelKey: disputeCompletedTranslationKey,
        status: 'completed',
        icon: _jsx(FontAwesomeIcon, { icon: faCheck })
    }
];
var disputeApprovedSteps = [
    {
        labelKey: disputeOpenedTranslationKey,
        status: 'completed'
    },
    {
        labelKey: disputeUnderReviewTranslationKey,
        status: 'completed'
    },
    {
        labelKey: disputeApprovedTranslationKey,
        status: 'completed',
        icon: _jsx(FontAwesomeIcon, { icon: faCheck })
    }
];
var disputeDeniedSteps = [
    {
        labelKey: disputeOpenedTranslationKey,
        status: 'completed'
    },
    {
        labelKey: disputeUnderReviewTranslationKey,
        status: 'completed'
    },
    {
        labelKey: disputeDeniedTranslationKey,
        status: 'completed',
        icon: _jsx(FontAwesomeIcon, { icon: faCheck })
    }
];
var disputeCancelationCompletedSteps = [
    {
        labelKey: disputeOpenedTranslationKey,
        status: 'completed'
    },
    {
        labelKey: cancelationPendingTranslationKey,
        status: 'completed'
    },
    {
        labelKey: disputeCompletedTranslationKey,
        status: 'completed',
        icon: _jsx(FontAwesomeIcon, { icon: faCheck })
    }
];
var disputeCancelationPendingSteps = [
    {
        labelKey: disputeOpenedTranslationKey,
        status: 'completed'
    },
    {
        labelKey: cancelationPendingTranslationKey,
        status: 'active'
    },
    {
        labelKey: disputeCompletedTranslationKey,
        status: 'upcoming'
    }
];
var statusesData = (_a = {},
    _a[TransactionStatus.SET_1] = disputeOpenedSteps,
    _a[TransactionStatus.SET_2] = disputeUnderReviewSteps,
    _a[TransactionStatus.SET_3] = disputeUnderReviewSteps,
    _a[TransactionStatus.SET_4] = disputeUnderReviewSteps,
    _a[TransactionStatus.SET_5] = disputeUnderReviewSteps,
    _a[TransactionStatus.SET_6] = disputeUnderReviewSteps,
    _a[TransactionStatus.SET_7] = disputeUnderReviewSteps,
    _a[TransactionStatus.SET_8] = disputeDeniedSteps,
    _a[TransactionStatus.SET_9] = disputeApprovedSteps,
    _a[TransactionStatus.SET_10] = disputeApprovedSteps,
    _a[TransactionStatus.SET_11] = disputeCancelationCompletedSteps,
    _a[TransactionStatus.SET_12] = disputeCompletedSteps,
    _a[TransactionStatus.SET_13] = disputeCompletedSteps,
    _a[TransactionStatus.SET_14] = disputeCompletedSteps,
    _a[TransactionStatus.SET_15] = disputeCompletedSteps,
    _a[TransactionStatus.SET_16] = disputeCompletedSteps,
    _a[TransactionStatus.SET_17] = disputeCompletedSteps,
    _a[TransactionStatus.SET_18] = disputeCompletedSteps,
    _a[TransactionStatus.SET_19] = disputeCompletedSteps,
    _a[TransactionStatus.SET_20] = disputeCompletedSteps,
    _a[TransactionStatus.SET_21] = disputeCancelationPendingSteps,
    _a[TransactionStatus.SET_22] = disputeUnderReviewSteps,
    _a[TransactionStatus.SET_23] = disputeCompletedSteps,
    _a[TransactionStatus.SET_24] = disputeCompletedSteps,
    _a[TransactionStatus.SET_25] = disputeCompletedSteps,
    _a);
var statusesWithTooltip = [
    TransactionStatus.SET_1,
    TransactionStatus.SET_2,
    TransactionStatus.SET_3,
    TransactionStatus.SET_4
];
var formatTransactionDate = function (transactionDate) {
    var date = new Date(transactionDate);
    return format(date, 'MMM d, yyyy');
};
var DisputeTracker = function () {
    var selectedTransaction = useSelectedDispute().selectedTransaction;
    var transactionStatus = selectedTransaction.statusCode;
    var transactionStartDate = selectedTransaction.requestCreationDate;
    var transactionEndDate = selectedTransaction.requestClosedDate;
    var estimatedEndDate = transactionStartDate
        ? addDays(new Date(transactionStartDate), 59)
        : null;
    var displayEndDate = transactionEndDate || estimatedEndDate;
    var formattedTransactionStartDate = formatTransactionDate(transactionStartDate);
    var formattedTransactionEndDate = transactionEndDate
        ? formatTransactionDate(transactionEndDate)
        : "Est. ".concat(formatTransactionDate(displayEndDate));
    var isEstimatedEndDate = !transactionEndDate;
    var isPastEstimatedDate = isAfter(new Date(), estimatedEndDate);
    var shouldShowTooltip = function (isLast) {
        return (statusesWithTooltip.includes(transactionStatus) &&
            isLast &&
            isPastEstimatedDate);
    };
    var statusData = statusesData[transactionStatus];
    var formattedSteps = statusData.map(function (_a, index) {
        var labelKey = _a.labelKey, status = _a.status, icon = _a.icon;
        var isFirst = index === 0;
        var isLast = index === statusData.length - 1;
        return {
            icon: icon,
            status: status,
            label: t(labelKey),
            info: (_jsxs(StepDate, __assign({ "$estimatedDate": isLast && isEstimatedEndDate, "data-cy": "step-date-".concat(isLast ? 'completed' : 'created').concat(isLast && isEstimatedEndDate ? '-estimated' : '') }, { children: [isFirst && formattedTransactionStartDate, isLast && formattedTransactionEndDate, ' ', shouldShowTooltip(isLast) && _jsx(TrackerToolTip, {})] })))
        };
    });
    return _jsx(Stepper, { steps: formattedSteps });
};
export default DisputeTracker;
//# sourceMappingURL=index.js.map